"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/* eslint-disable no-const-assign, no-unused-vars */
var ACLUISetup = window.ACLUISetup || {};

ACLUISetup = {
  aclPanel: function aclPanel() {
    var $overlay = $("<div/>", { class: "acl-panel-overlay" });
    var $panel = $(".acl-panel");
    var $panelTrigger = $('[data-toggle="acl-panel"]');
    var $panelClose = $panel.find(".panel__close");
    var $panelParent = $panel.parent();
    var $doc = $(document);
    var hasOverlay = $panel.data("has-overlay");
    var clickableOverlay = $panel.data("clickable-overlay");

    var closePanel = function closePanel() {
      $panel.removeClass("is-open");
      $doc.off("keyup", handleEsc); // eslint-disable-line no-use-before-define
      $overlay.remove();
    };

    var handleEsc = function handleEsc(e) {
      if (e.keyCode === 27) {
        closePanel();
      }
    };

    // trigger panel
    $panelTrigger.on("click", function () {
      $panel.addClass("is-open");

      // Add event listener for closing panel with `esc`
      $doc.on("keyup", handleEsc);

      if (hasOverlay) {
        $panel.after($overlay);
      }
    });

    // close panel
    $panelClose.on("click", closePanel);
    if (clickableOverlay) {
      $panelParent.on("click", ".acl-panel-overlay", closePanel);
    }
  }
};

exports.default = ACLUISetup;